import { FaviconProvider } from "@mcleod/core";

export class LMEFaviconProvider extends FaviconProvider {
    public override getIconPath(key: string): string {
        return key != null ? `/icons/${key}.png` : null;
    }

    public override get defaultFaviconPath(): string {
        return "/icons/frame_icon_main.png";
    }
}
